<template>
  <component :is="transitionComponent">
    <router-view :key="path" />
  </component>
</template>

<script lang="ts" setup>
import { useRouterTransition } from '@/modules/common/composables/useRouterTransition';

const { path, transitionComponent } = useRouterTransition();
</script>
